<template>
  <div v-if="isVisible" class="modal-overlay" @click="closeModal">
    <div class="modal-container" @click.stop>
      <div class="success-icon">
        <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="40" cy="40" r="40" fill="#86D68A"/>
          <path d="M56 30L34 52L24 42" stroke="white" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </div>

      <div class="success-content">
        <h2 class="success-title">Tebrikler, işlem başarılı</h2>
        <p class="success-description">
          Yeni paketiniz aktifleştirildi ve yeni<br>
          kullanım haklarınız tanımlandı.
        </p>
      </div>
      <button
          class="success-button"
          @click="handleFinish"
          :disabled="buttonDisabled"
      >
        {{ buttonText }}
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PricingSuccessModal',
  props: {
    isVisible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      buttonDisabled: false,
      buttonText: 'Bitti'
    }
  },
  methods: {
    handleFinish() {
      try {
        this.$emit('close');
        if (window && window.location) {
          window.location.href = '/billing?confetti=true';
        }
      } catch (error) {
        this.$emit('close');
      }
    },

    closeModal() {
      try {
        this.buttonDisabled = false;
        this.buttonText = 'Bitti';
        this.$emit('close');
      } catch (error) {
        this.$emit('close');
      }
    }
  },
}
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1003;
  backdrop-filter: blur(4px);
}

.modal-container {
  background: #ffffff;
  border-radius: 24px;
  width: 400px;
  height: 400px;
  padding: 48px 32px 32px;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  overflow: hidden;
}

.success-icon {
  margin-bottom: 24px;
  z-index: 5;
  position: relative;
}

.success-content {
  margin-bottom: 32px;
  z-index: 5;
  position: relative;
}

.success-title {
  font-size: 24px;
  font-weight: 600;
  color: #111827;
  margin: 0 0 12px 0;
  font-family: 'euclid_semi_bold', sans-serif;
}

.success-description {
  font-size: 14px;
  color: #6b7280;
  margin: 0;
  line-height: 1.6;
  font-family: 'euclid_regular', sans-serif;
}

.success-button {
  background: #111827;
  color: white;
  border: none;
  border-radius: 16px;
  padding: 12px 32px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  font-family: 'euclid_medium', sans-serif;
  min-width: 120px;
  z-index: 5;
  position: relative;
}

.success-button:hover:not(:disabled) {
  transform: translateY(-1px);
  background: #1f2937;
}

.success-button:disabled {
  opacity: 0.7;
  cursor: not-allowed;
  transform: none;
}

@media (max-width: 768px) {
  .modal-container {
    width: 90%;
    max-width: 400px;
    margin: 20px;
    padding: 32px 24px 24px;
  }

  .success-title {
    font-size: 20px;
  }

  .success-description {
    font-size: 13px;
  }
}
</style>
